module.exports = __webpack_public_path__ + "img/4.d18e89f1.png";